import bean from '~/bean';
import Viewport from '~/components/popup/viewport';

class Manager {
    constructor() {
        this._mode = 'hideViewportScrollbars';
        if (this.mode() == 'hideViewportScrollbars')
            this._viewport = new Viewport;
    }

    adopt(popup) {
        if (this.mode() == 'hideViewportScrollbars')
            this._viewport.hideScrollbars();
        this._popup = popup;
        this._popup.options({
            mode: this.mode(),
            noPopupScrollbarState: this._viewport ?
                this._viewport.noPopupScrollbarState.bind(this._viewport)
            : null,
            afterShow: () => {
                this.__keydownEventHandler = this._keydownEventHandler.bind(this);
                bean.on(window, 'keydown', this.__keydownEventHandler);
                bean.fire(popupManager, 'afterShow');
            },
            onUpdateExtents: event => {
                bean.fire(popupManager, 'updateExtents', event);
            },
            beforeDestroy: () => {
                bean.fire(popupManager, 'beforeDestroy');
                bean.off(window, 'keydown', this.__keydownEventHandler);
            },
            afterDestroy: () => {
                this._popup = null;
                if (this.mode() == 'hideViewportScrollbars')
                    this._viewport.showScrollbars();
                bean.fire(popupManager, 'afterDestroy');
            },
        });
    }


    _keydownEventHandler(e) {
        if ( ! this._popup)
            return;
        switch (e.key) {
        case 'Enter':
            if (e.originalEvent.enterHasBeenHandled) {
                break;
            }
            if (e.target.tagName == 'TEXTAREA')
                break;
            if (this._popup.onEnter() == false)
                break;
            this._popup.destroy();
            break;

        case 'Escape':
            this._popup.destroy();
            break;
        }
    }

    markEnterAsHandled(e) {
        if (e.key != 'Enter')
            return;
        e.originalEvent.enterHasBeenHandled = true;
    }

    _resizeEventHandler() {
        if (this.mode() == 'hideViewportScrollbars')
            this._viewport.updateExtents();
        this._popup.updateExtents('windowResize');
    }


    noPopupPageXOffset() {
        return this._viewport.noPopupPageXOffset();
    }

    noPopupPageYOffset() {
        return this._viewport.noPopupPageYOffset();
    }

    noPopupViewportClientWidth() {
        return this._viewport.noPopupClientWidth();
    }

    noPopupViewportClientHeight() {
        return this._viewport.noPopupClientHeight();
    }


    popupShown() {
        return this._popup && this._popup.shown();
    }

    popupBoundingClientRect() {
        return this._popup && this._popup.getBoundingClientRect();
    }


    mode() {
        return this._mode;
    }
}

const popupManager = new Manager;
export default popupManager;

bean.on(window, 'resize', e => {
    if (popupManager.popupShown())
        popupManager._resizeEventHandler(e);
    else
        bean.fire(popupManager, 'updateExtents', 'windowResize');
});



// WEBPACK FOOTER //
// ./makosh/assets/components/popup/manager.js